import clsx from 'clsx'
import { CalendarDays, LayoutDashboard, ShoppingBag, SlidersHorizontal, Users } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useVendorAuth } from '@/auth/VendorAuthProvider'

interface NavItem {
  to: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  end?: boolean
  tourId?: string
}

// Vendedor: su home es el Dashboard (Inicio).
const VENDOR_ITEMS: NavItem[] = [
  { to: '/', label: 'Inicio', icon: LayoutDashboard, end: true },
  { to: '/catalogo', label: 'Catálogo', icon: ShoppingBag, tourId: 'nav-catalogo' },
  { to: '/clientes', label: 'Clientes', icon: Users, tourId: 'nav-clientes' },
  { to: '/calendario', label: 'Novedades', icon: CalendarDays, tourId: 'nav-novedades' },
]

// Admin (Koru): NO tiene Dashboard de vendedor → sin "Inicio". Su home es el Panel.
const ADMIN_ITEMS: NavItem[] = [
  { to: '/admin', label: 'Panel', icon: SlidersHorizontal },
  { to: '/catalogo', label: 'Catálogo', icon: ShoppingBag },
  { to: '/clientes', label: 'Clientes', icon: Users },
  { to: '/calendario', label: 'Novedades', icon: CalendarDays },
]

export function BottomNav() {
  const { vendor } = useVendorAuth()
  const items = vendor?.isAdmin ? ADMIN_ITEMS : VENDOR_ITEMS

  return (
    <nav className="bottom-nav">
      {items.map(({ to, label, icon: Icon, end, tourId }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-tour={tourId}
          className={({ isActive }) => clsx('nav-item', isActive && 'nav-item-active')}
        >
          <Icon className="h-5 w-5" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
